import React from 'react'
import { Tab, Icon, Header } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import MobileOrgDetail from './mobileOrgDetail'
import Welcome from './welcome'
import { getDetails, checkUsername } from '../utility'
import '../css/detail-view.css'

export default class MobileViewDetail extends React.Component {
  render () {
    const { match } = this.props
    const { params } = match
    const panes = checkUsername(params.username)
      ? getDetails(params.username).proposals.map((proposal, index) => {
        return {
          menuItem: {
            key: index,
            icon: proposal.selected == '1' ? 'flag checkered' : false,
            content: `Proposal ${index + 1}`
          },
          render: () => (
            <Tab.Pane>
              <MobileOrgDetail proposal={proposal} />
            </Tab.Pane>
          )
        }
      })
      : []

    return checkUsername(params.username) ? (
      <div className='scrollable-section'>
        <div className='header-mobile-org' style={{ paddingBottom: '1rem' }}>
          <div>
            <Link to='/'>
              <Icon
                name='chevron left'
                size='big'
                style={{ color: 'initial' }}
              />
            </Link>
          </div>
          <Header as='h2'>
            <Header.Content>
              {getDetails(params.username)['Name of the applicant']}
              <Header.Subheader>
                {getDetails(params.username)['Year']}
              </Header.Subheader>
            </Header.Content>
          </Header>
        </div>
        <Tab panes={panes} />
      </div>
    ) : (
      <Welcome />
    )
  }
}
